import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Box, Divider, Paper, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom'
import { useTranslation } from 'react-i18next'

import { useGetCaseStatisticsQuery } from '../../../features/cases/caseSlice'
import { CaseStatus } from '../../case-management/case.status'
import Stat from './Stat'
import HeaderPanel from './HeaderPanel'

const iconByStatus = {
  CLOSED_WITHOUT_ACTIONS: CheckCircleIcon,
  CLOSED_WITH_ACTIONS: CheckCircleIcon,
  REVIEW_IN_PROGRESS: HourglassBottomIcon,
  PENDING: HourglassBottomIcon,
  REVIEW_FINISHED: HourglassBottomIcon,
}

const CasesStats = () => {
  const { period } = useSelector((state) => state.statistics)

  const { t } = useTranslation(['messages', 'common'])

  const { data: statisticsResponse } = useGetCaseStatisticsQuery({ type: 'by_status', period })
  const { data: statistics } = statisticsResponse || { data: [] }

  const total = useMemo(() => statistics.reduce((acc, item) => acc + item.total || 0, 0), [statistics])
  const totalByStatus = useMemo(
    () =>
      statistics.reduce((acc, item) => {
        acc[item._id] = item.total
        return acc
      }, {}),
    [statistics],
  )

  return (
    <Paper elevation={0} className="cases-stats">
      <Box className="case-stats-header">
        <Typography variant="text4">{t('messages:statistics.cases.title.resume')}</Typography>
        <HeaderPanel />
      </Box>
      <Divider sx={{ marginTop: '.75rem' }} />
      <Box className="stat-wrapper">
        <Stat total={total} title="Total" />

        {CaseStatus.map((status, index) => {
          const Icon = iconByStatus[status]
          const total = totalByStatus[status] || 0
          return (
            <Stat key={index} total={total} title={t(`messages:statistics.cases.states.${status}`)} icon={<Icon />} />
          )
        })}
      </Box>
    </Paper>
  )
}

export default CasesStats
